export default new class {

  get = (endpoint: string, queryParams?: string) => {
    const uri = queryParams ? 
      `${ process.env.REACT_APP_API_URL }/api/julius/${ endpoint }?${ queryParams}` :
      `${ process.env.REACT_APP_API_URL }/api/julius/${ endpoint }`;

    return fetch(encodeURI(uri), {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    });
  }

  post = (endpoint: string, data: any) => {
    const uri = `${ process.env.REACT_APP_API_URL }/api/julius/${ endpoint }`;

    return fetch(encodeURI(uri), {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify(data),
    });
  }
    
  put = (endpoint: string, data: any) => {
    const uri = `${ process.env.REACT_APP_API_URL }/api/julius/${ endpoint }`;

    return fetch(encodeURI(uri), {
      method: 'PUT',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify(data),
    });
  }
    
  delete = (endpoint: string, queryParams?: string, data?: any) => {
    const uri = queryParams ? 
      `${ process.env.REACT_APP_API_URL }/api/julius/${ endpoint }?${ queryParams}` :
      `${ process.env.REACT_APP_API_URL }/api/julius/${ endpoint }`;

    return fetch(encodeURI(uri), {
      method: 'DELETE',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: data ? JSON.stringify(data) : undefined,
    });
  }
}


// WEBPACK FOOTER //
// ./src/helpers/Api.tsx